module.exports = __webpack_public_path__ + "static/img/wuxian-4.7bc2069d.png";